var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import cx from "clsx";
import Typography from "../../../../compara-ui/components/Typography";
import { CategoryPanel } from "../Category/CategoryPanel";
import { getLoggedUser, getMenuConfig, handleClickAvatar } from "./helpers";
import { UserAccountButton } from "./UserAccountButton";
import { DEFAULT_AVATAR } from "./constants";
import { getUserAccountData } from "./getData";
export var UserAccountMenu = function (_a) {
    var _b;
    var businessUnit = _a.businessUnit, country = _a.country, messages = _a.messages, isNavbarOpen = _a.isNavbarOpen, setNavbarOpen = _a.setNavbarOpen, isOpen = _a.isOpen, setOpen = _a.setOpen;
    var _c = useState(), user = _c[0], setUser = _c[1];
    var BASE_URL = getMenuConfig().BASE_URL;
    var _d = getUserAccountData(businessUnit, country, messages)[0], loggedMenu = _d.loggedMenu, unloggedMenu = _d.unloggedMenu, logoutLink = _d.logoutLink;
    var isLogged = Boolean(user && user.uid);
    var avatar = (_b = user === null || user === void 0 ? void 0 : user.picture) !== null && _b !== void 0 ? _b : DEFAULT_AVATAR;
    var links = isLogged ? loggedMenu : unloggedMenu;
    var panelClass = cx("account-menu flex flex-col absolute left-1/2 -translate-x-1/2 md:w-64 md:left-auto md:pb-0", {
        "max-h-0": !isOpen,
        "pb-2 max-h-26 md:max-h-20": isOpen,
    });
    var linkClass = "px-4 py-3 hover:font-bold md:py-2";
    useEffect(function () {
        if (isNavbarOpen) {
            setOpen(false);
        }
    }, [isNavbarOpen, setOpen]);
    useEffect(function () {
        function getUserFromDB() {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = setUser;
                            return [4 /*yield*/, getLoggedUser()];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getUserFromDB();
    }, []);
    return (React.createElement("div", { className: "w-16 h-16 md:relative" },
        React.createElement(UserAccountButton, { businessUnit: businessUnit, country: country, avatar: avatar, onClick: function () { return handleClickAvatar(setOpen, setNavbarOpen); }, isOpen: isOpen }),
        React.createElement(CategoryPanel, { transitionClass: "transition-max-h duration-300 ease-linear md:duration-200 md:ease-in-out", shapeClass: "rounded-none md:rounded-b-lg", className: panelClass, "aria-expanded": isOpen },
            links.map(function (_a, index) {
                var href = _a.href, label = _a.label;
                return (React.createElement(Typography, { component: "a", variant: "body1", className: linkClass, color: "text-text-primary", key: "UserAccountMenu-link-" + index, href: "" + BASE_URL + href }, label));
            }),
            isLogged ? (React.createElement(Typography, { component: "a", variant: "body1", color: "text-text-primary", className: cx(linkClass, "border-t border-gray-100"), href: "" + BASE_URL + logoutLink.href }, logoutLink.label)) : null)));
};
//# sourceMappingURL=UserAccountMenu.js.map